import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { escapeHTML, transformPrompt } from '../../../utils';
import { getAnswerClass } from '../utils';
import ReactIcon from '../../Icons';

const zoomIcon = ReactIcon({ type: 'zoom_in' });
const parser = new DOMParser();
export default function AnswerWithImage({
  answer,
  question,
  containsOnlyEmoji,
  handleTap = noop,
}) {
  const imageToShow = answer.optimized_image_url || answer.image_url;
  const originalAnswerImage = answer.image_url;
  const answerClass = getAnswerClass({ question, answer, containsOnlyEmoji });
  let answerBody = answer.body;

  try {
    const parsedText = parser
      .parseFromString(answer.body || '', 'text/html')
      .body.textContent.trim();
    if (!parsedText) {
      answerBody = '';
    }
  } catch (e) {
    answerBody = answer.body;
  }
  answerBody = transformPrompt(answerBody);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      id={answer.id}
      className={`answer answer--with-image ${answerClass}`}
      onClick={handleTap}
      role="button"
      tabIndex={0}
    >
      <div className="answer__image__container">
        <img
          src={imageToShow}
          alt={escapeHTML(answerBody)}
          className="answer__image"
        />
        <button
          type="button"
          className="answer__image__button js-zoom-image"
          data-img-src={originalAnswerImage}
          aria-label="Zoom image"
        >
          {zoomIcon}
        </button>
      </div>
      <div
        className="answer__description inline-children"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: answerBody || '&nbsp;' }}
      ></div>
    </div>
  );
}

AnswerWithImage.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object,
  containsOnlyEmoji: PropTypes.bool,
  handleTap: PropTypes.func,
};
